import api from "./api";

export const getPayment = (reference) =>
  api.get(`/payment/${reference}`).then((res) => res.data);

// cash/bank — সাথে সাথে JSON রেসপন্স দেয়। extra তে name/phone/cash_location
// পাঠানো হয় (backend "cash" method এর জন্য এগুলো require করে)।
export const processOfflinePayment = (reference, method, extra = {}) =>
  api.post(`/payment/${reference}`, { method, ...extra }).then((res) => res.data);

// bKash/Nagad/Card (SSLCommerz) — JSON এ redirect_url পাওয়া যায়, তারপর
// window.location.href = redirect_url দিয়ে gateway তে পাঠাতে হবে
// (নিচের pages/payment/index.js এ দেখো)
export const initiateSslcommerz = (reference) =>
  api.post(`/payment/${reference}/sslcommerz`).then((res) => res.data);
